/*=========================================================================================
  File Name: moduleCustomerActions.js
  Description: Customer Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import axios from "@/plugins/axios";
import { CustomerEntityModel } from "@/models/EntityModels/CustomerEntityModel";
import { identity } from "lodash";

export default {
  //reset the password by get token from api


  async CreateGuest({}, Credentials) {
    

    
    return new Promise((resolve, reject) => {
      axios
        .post("hms/guests", Credentials)
        .then((resp) => {
          console.log("Request succeeded");
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },
  async GetGuests({}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`hms/guests`)
        .then((resp) => {
          console.log("Request succeeded");
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },
 
 
  async EditGuest({}, Credentials) {
    
    let customer_id = Credentials.id;
    delete Credentials.id;


    return new Promise((resolve, reject) => {
      axios
        .patch(`hms/guests/${customer_id}`, Credentials)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },

  async GetGuest({}, Id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`hms/guests/${Id}`)
        .then((resp) => {
        
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },
  ArchiveOrActiceGuest({}, Credentials) {
    return new Promise((resolve, reject) => {
      axios
        .get(`hms/guests/${Credentials.id}/soft-delete`)
        .then((resp) => {
          console.log("resp.data", resp.data.data);
          resolve(resp.data.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

 


  GetGuestSearch({}, payload) {
    let url = "hms/guests/search?";
    if (payload != null && payload != undefined) {
      if (payload.query != "" && payload.query != null) {
        url += `query=${payload.query}&`;
      }
      if (payload.status != "" && payload.status != null) {
        url += `status=${payload.status}&`;
      }

      if (
        payload.except != undefined &&
        payload.except != null &&
        payload.except.length > 0
      ) {
        url += `except=[${payload.except}]`;
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp.data.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  async UploadGuestImage({}, Credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post(`hms/guests/${Credentials.get("id")}/image-upload`, Credentials)
        .then((resp) => {
          console.log("Request succeeded");
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },
};
